import { render, staticRenderFns } from "./address-index.vue?vue&type=template&id=13705804&scoped=true"
import script from "./address-index.vue?vue&type=script&lang=js"
export * from "./address-index.vue?vue&type=script&lang=js"
import style0 from "./address-index.vue?vue&type=style&index=0&id=13705804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13705804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13705804')) {
      api.createRecord('13705804', component.options)
    } else {
      api.reload('13705804', component.options)
    }
    module.hot.accept("./address-index.vue?vue&type=template&id=13705804&scoped=true", function () {
      api.rerender('13705804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/address/address-index.vue"
export default component.exports